export class NovoProcesso {
  pasta: string;
  titulo: string;
  tipoAcao: number;
  descricao: string;
  nomeOutraParte: string;
  outraParte: number;
  solicitante: number;
  atendimento: number;
  responsavel: number;
}
